"use strict";
// function required(envName: string) {
//   if (process.env[envName]) {
//     return process.env[envName]!;
//   }
//   console.error('Environment:', process.env);
//   throw new Error(
//     `The environment variable '${envName}' is required to run and build this project. More information available in the console.`,
//   );
// }
Object.defineProperty(exports, "__esModule", { value: true });
var config = {
    debug: false,
    urls: {
        base: process.env.EXPO_PUBLIC_BASE_URL || process.env.REACT_APP_BASE_URL,
        web: process.env.EXPO_PUBLIC_WEB_URL || process.env.REACT_APP_WEB_URL,
        api: process.env.EXPO_PUBLIC_API_URL || process.env.REACT_APP_API_URL,
        signup: 'auth/registration/',
        login: 'auth/login/',
        loginWithFacebook: 'auth/facebook/',
        loginWithTwitter: 'auth/twitter/',
        loginWithGoogle: 'auth/google/',
        connectFacebook: 'auth/facebook/connect/',
        connectTwitter: 'auth/twitter/connect/',
        connectGoogle: 'auth/google/connect/',
        logout: 'auth/logout/',
        logoutall: 'auth/logoutall/',
        firebaseToken: 'auth/firebase/',
        changePassword: 'auth/password/change/',
        resetPassword: 'auth/password_reset/',
        resetPasswordConfirm: 'auth/password_reset/confirm/',
        loads: 'loads/',
        additionalBilling: 'loads/additional-billing/',
        additionalBillingDocuments: 'loads/additional-billing-documents/',
        loadDocuments: 'loads/documents/',
        loadDocumentPhotos: 'loads/document-photos/',
        manifests: 'loads/manifests/',
        driverSchedules: 'driverschedule/',
        activeDriverSchedule: 'driverschedule/driver_get_active_schedule/',
        completedDriverSchedule: 'driverschedule/driver_get_completed_schedule/',
        proposedDriverSchedule: 'driverschedule/driver_get_proposed_schedule/',
        driverScheduleOrders: 'driverschedule/driver_orders_in_schedule/',
        driverScheduleOrderLegs: 'driverschedule/driver_order_legs_in_schedule/',
        driverCompletedOrderLegs: 'driverschedule/driver_completed_order_legs_in_schedule/',
        driverAcceptSchedule: 'driverschedule/driver_accept_schedule/',
        permits: 'permits/',
        scheduleRow: 'driverschedule/schedulerow/',
        socialAccounts: 'auth/socialaccounts/',
        trucks: 'loads/trucks/',
        twitterRequestToken: 'auth/twitter/request-token/',
        twitterAccessToken: 'auth/twitter/access-token/',
        vehicleTypes: 'loads/vehicle-types/',
        locations: 'locations/',
        user: 'users/',
        organizations: 'users/organizations/',
        notifications: 'notifications/',
        ws: process.env.EXPO_PUBLIC_WS_URL || process.env.REACT_APP_WS_URL,
        privacyPolicy: "".concat(process.env.EXPO_PUBLIC_WEB_URL ||
            process.env.REACT_APP_WEB_URL, "privacypolicy/"),
    },
    tokenKey: process.env.EXPO_PUBLIC_FIREBASE_TOKEN_KEY ||
        process.env.REACT_APP_FIREBASE_TOKEN_KEY ||
        'TOKEN_KEY',
    firebaseConfig: {
        apiKey: process.env.EXPO_PUBLIC_FIREBASE_API_KEY ||
            process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN ||
            process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.EXPO_PUBLIC_FIREBASE_DATABASE_URL ||
            process.env.REACT_APP_FIREBASE_DATABASE_URL,
        projectId: process.env.EXPO_PUBLIC_FIREBASE_PROJECT_ID ||
            process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET ||
            process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID ||
            process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.EXPO_PUBLIC_FIREBASE_APP_ID ||
            process.env.REACT_APP_FIREBASE_APP_ID,
        measurementId: process.env.EXPO_PUBLIC_FIREBASE_MEASUREMENT_ID ||
            process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    },
    googleMapsApiKey: {
        web: process.env.EXPO_PUBLIC_WEB_GOOGLE_MAPS_API_KEY ||
            process.env.REACT_APP_WEB_GOOGLE_MAPS_API_KEY,
        ios: process.env.EXPO_PUBLIC_IOS_GOOGLE_MAPS_API_KEY ||
            process.env.REACT_APP_IOS_GOOGLE_MAPS_API_KEY,
        android: process.env.EXPO_PUBLIC_ANDROID_GOOGLE_MAPS_API_KEY ||
            process.env.REACT_APP_ANDROID_GOOGLE_MAPS_API_KEY,
    },
    googleSignInConfig: {
        iosClientId: process.env.EXPO_PUBLIC_GOOGLE_SIGN_IN_IOS_CLIENT_ID ||
            process.env.REACT_APP_GOOGLE_SIGN_IN_IOS_CLIENT_ID,
        androidClientId: process.env.EXPO_PUBLIC_GOOGLE_SIGN_IN_ANDROID_CLIENT_ID ||
            process.env.REACT_APP_GOOGLE_SIGN_IN_ANDROID_CLIENT_ID,
        iosStandaloneAppClientId: process.env.EXPO_PUBLIC_GOOGLE_SIGN_IN_IOS_STANDALONE_CLIENT_ID ||
            process.env.REACT_APP_GOOGLE_SIGN_IN_IOS_STANDALONE_CLIENT_ID,
        androidStandaloneAppClientId: process.env.EXPO_PUBLIC_GOOGLE_SIGN_IN_ANDROID_STANDALONE_CLIENT_ID ||
            process.env.REACT_APP_GOOGLE_SIGN_IN_ANDROID_STANDALONE_CLIENT_ID,
        clientId: process.env.EXPO_PUBLIC_GOOGLE_SIGN_IN_CLIENT_ID ||
            process.env.REACT_APP_GOOGLE_SIGN_IN_CLIENT_ID,
    },
    dynamsoftAPiKey: 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAyODc2NDMwLVRYbE5iMkpwYkdWUWNtOXEiLCJtYWluU2VydmVyVVJMIjoiaHR0cHM6Ly9tZGxzLmR5bmFtc29mdG9ubGluZS5jb20vIiwib3JnYW5pemF0aW9uSUQiOiIxMDI4NzY0MzAiLCJzdGFuZGJ5U2VydmVyVVJMIjoiaHR0cHM6Ly9zZGxzLmR5bmFtc29mdG9ubGluZS5jb20vIiwiY2hlY2tDb2RlIjotMTQ5Mzk4NjM3MH0=',
};
exports.default = config;
